import angular from 'angular'
import vehicleProducerPage from './view/vehicleProducer.html'

class vehicleProducerCtrl {
    constructor($scope, httpRequest, sweetalert) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                allStr: '',
            },
        }

        $scope.queryList = function queryList() {
            httpRequest.post_getSysVehicleCompanyList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()
        $scope.importconfig = {
            code: 'VEHICLE_COMPANY',
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            callback() {
                $scope.queryList()
            },
        }
        $scope.upload = function upload() {
            const msg = '导入后将全面覆盖已有的生产企业名称列表，确定要导入吗？'
            sweetalert.confirm('确认上传', msg).then(() => {
                angular.element('#vehicleProducer_uploadFiles .j-importexcel').click()
            }, () => {})
        }
    }
}
vehicleProducerCtrl.$inject = ['$scope', 'httpRequest', 'sweetalert']
export default angular.module('system.basedata.vehicleInfoTab.vehicleProducer', [])
    .controller('vehicleProducerCtrl', vehicleProducerCtrl)
    .component('vehicleProducer', {
        template: vehicleProducerPage,
        controller: 'vehicleProducerCtrl',
    }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/vehicleInfo/vehicleProducerComponent.js